<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col w-full h-full">
      <div class="w-full my-auto">
        <section class="mb-4 text-center">
          <h1>
            <span
              class="text-outline text-title-sm lg:text-title-md"
              v-text="page.titolo1"
            /><br />
            <span
              class="text-title-md lg:text-title-lg leading-none md:leading-none"
              v-text="page.titolo2"
            />
          </h1>
          <div class="prose flex flex-col items-center">
            <span>
              Hai sempre un interesse, indicizzato all'Euribor 3 mesi meno 1,40
              punti percentuali
            </span>
            <span>
              Scegli il pacchetto che fa per te e scopri come scontare il
              canone. Con il pacchetto <b>Semplice</b>, puoi addirittura
              azzerarlo.
            </span>
            <span>
              Provalo gratis per 3 mesi, accredita lo stipendio/pensione e
              partecipi all'estrazione di un viaggio a Parigi. Consulta il
              <a
                href="https://www.iblbanca.it/-/media/project/ibl/corporate/documenti/trasparenza/regolamenti-manifestazioni-a-premi/IBL_Club-Informativa_Legale_e_Regolamenti.pdf"
                target="_blank"
                >regolamento</a
              >
              e scopri come partecipare.
            </span>
            <span>
              Trasferisci il tuo conto in IBL Banca, pensiamo a tutto noi!
            </span>
          </div>
        </section>
        <section class="flex flex-wrap items-stretch mb-4"></section>
        <!-- :thumbs="{ swiper: thumbsSwiper }" -->
        <app-slider
          :items="packages"
          :space-between="8"
          :controller="{
            control: thumbsSwiper,
            by: 'slide'
          }"
          :breakpoints="{
            1024: { slidesPerView: 2 },
            768: { slidesPerView: 1 },
            640: { slidesPerView: 1 }
          }"
          @swiper="mainSwiper = $event"
          @slideChange="onMainChange"
        >
          <template #slide="item">
            <pacchetto-ibl v-bind="item" />
          </template>
        </app-slider>
        <swiper
          :controller="{
            control: mainSwiper,
            by: 'slide'
          }"
          class="swiper-nav lg:hidden"
          slides-per-view="auto"
          @swiper="thumbsSwiper = $event"
          @click="onThumbClicked"
          centered-slides
          centered-slides-bounds
          watch-slides-visibility
          watch-slides-progress
          slide-to-clicked-slide
        >
          <swiper-slide v-for="(item, i) in packages" :key="item.PackageId">
            <div
              v-text="item.Title"
              class="text-white hover-hover:hover:bg-primary hover-hover:hover:text-white rounded-3xl flex items-center justify-center w-40 h-12 px-6 mx-auto leading-tight text-center whitespace-normal cursor-pointer"
              :class="{ 'bg-white text-brand': activeThumb === i }"
            />
          </swiper-slide>
        </swiper>
        <app-cta-button
          cta
          mobile-only
          full-width
          :link="apriContoUrl"
          external
          button-style="brand"
        />
      </div>
    </div>
    <router-view v-slot="{ Component }">
      <transition name="pop">
        <component :is="Component" />
      </transition>
    </router-view>
    <!-- <div class="parallax absolute inset-0 flex items-center justify-center">
      <img class="max-h-96 " src="/img/bubble.png" />
    </div> -->
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import _ from "lodash";
import PacchettoIbl from "@/components/pacchetti/PacchettoIbl";
import { matchedRouteKey } from "vue-router";

export default {
  inject: [matchedRouteKey],
  components: { PacchettoIbl },
  data: () => ({
    packages: Array(),
    thumbsSwiper: undefined,
    mainSwiper: undefined,
    activeThumb: 0,
    megaPromoDate: new Date()
  }),
  computed: {
    navRoute() {
      return this[matchedRouteKey].value;
    }
  },
  methods: {
    onMainChange(swipe) {
      this.activeThumb = swipe.activeIndex;
    },
    onThumbClicked(swipe) {
      this.mainSwiper.slideTo(swipe.clickedIndex);
      this.activeThumb = swipe.clickedIndex;
    }
  },
  async beforeRouteEnter(to, from, next) {
    let page = Object();
    let packages = Array();
    try {
      packages = await axios.get(process.env.VUE_APP_PLUGIN_PACKAGE_API);
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = page || Object();
      packages = packages || Array();
    } finally {
      next(vm => {
        vm.page = page.data || Object();
        vm.packages = _.get(packages, "data.data.value") || Array();
      });
    }
  },
  async beforeRouteUpdate() {
    let page = Object();
    let packages = Array();
    try {
      page = await axios.get(`/pageContent${this.navRoute.path}.json`);
      packages = await axios.get(process.env.VUE_APP_PLUGIN_PACKAGE_API);
    } catch (error) {
      page = page || Object();
      packages = packages || Array();
    } finally {
      this.page = page.data || Object();
      this.packages = _.get(packages, "data.data.value") || Array();
    }
  },
  async mounted() {
    try {
      const response = await this.axios.get(
        `${process.env.VUE_APP_PLUGIN_GENERAL_API}/client-settings`
      );

      this.megaPromoDate = new Date(
        response.data.data.MegaPromoRequestableUntil.slice(0, -1)
      );

      this.megaPromoDate = this.megaPromoDate.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    } catch (error) {
      error;
    }
  }
};
</script>
<route>
{
  "name": "perchè",
  "meta": {
      "order": 2,
      "label": "I nostri Pacchetti"
  }
}
</route>
<style lang="postcss">
.swiper-nav {
  @apply bg-brand rounded-full max-w-min;
}
.swiper-nav .swiper-slide {
  @apply w-min;
}
div.prose span {
  margin-bottom: 0.75rem;
}
</style>
